import React from "react";
import HomeTable from "../../components/home/HomeTable";
import { Box } from "@mui/material";

export default function HomePage() {
  return (
    <Box>
      <HomeTable />
    </Box>
  );
}
